import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


import Modal from '@mui/material/Modal';

import Autocomplete from '@mui/material/Autocomplete';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

let strCust=[{title:'',year:0}];
const headCells = [
  
  { id: 'ldm_firstname', numeric: false, label: 'Name' },
  { id: 'ldm_emailid', numeric: false, label: 'Email ID' },
  { id: 'ldm_phoneno', numeric: false, label: 'Phone No.' },
    { id: 'Type', numeric: false, label: 'Type' },
	 { id: 'followupdate', numeric: false, label: 'Followup Date' },
	 { id: 'leadesource', numeric: false, label: 'Source' },
   { id: '',  label: '' },
  ]
  const headCellstatus = [
{ id: '', numeric: false, label: '' },
{ id: 'followupdate', numeric: false, label: 'Followup Date' },

{ id: 'type', numeric: false, label: 'Type' },


,

]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
/*new table head for display payment*/
function EnhancedTableHeadstatus(props) {
	const { classes, order, orderBy, rowCount, onRequestSort } = props;
	const createSortHandler = property => event => {
	onRequestSort(event, property);
};

return (
<TableHead>
<TableRow>
        
{headCellstatus.map(headCell => (
<TableCell
key={headCell.id}
align={headCell.numeric ? 'right' : 'left'}
padding={headCell.disablePadding ? 'none' : 'default'}
sortDirection={orderBy === headCell.id ? order : false}
>
<TableSortLabel
active={orderBy === headCell.id}
direction={orderBy === headCell.id ? order : 'asc'}
onClick={createSortHandler(headCell.id)}
>
{headCell.label}
{orderBy === headCell.id ? (
<span className={useStyles.visuallyHidden}>
{order === 'desc' ? ' ' : ' '}
</span>
) : null}
</TableSortLabel>
</TableCell>
))}
</TableRow>
</TableHead>
);
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

/*new status section*/
EnhancedTableHeadstatus.propTypes = {
	classes: PropTypes.object.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};
/*end of new status section*/
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
const style = ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
});

export default class  AddLeadstatusbox extends Component {
	constructor(props) {
		super(props)
		
		this.state = {
		open:false,
		  open:false,redirect: false,pagename:'',btnsave:false,
      Leadstatusdata:[],lsid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:4,rowsPaging:[],customerrauto:[],cuid:0, custid:0,selectedcustomerexchange:[],custarray:[],
	 
	  order:'desc',ls_id:0 ,orderBy:'',type:'',
	  fromdate:'',todate:'',lsldmid:'', followupdate:'',followupdate1:'',   ls_reasonforlost:0, ls_movedtoaddress:'',
    		
		}
		this.onTagscustomerexchange = this.onTagscustomerexchange.bind(this);
		this.updateDonenewParent = this.updateDonenewParent;
	}
	
onInputCustChange = (event, newTextValue) => {
	
	if(newTextValue!==" "){
	  this.setState({custid:newTextValue})
	} 
}	
 onTagscustomerexchange = (event, values) => {
	if(values!==" " && values!==null){
		this.setState({
		custid:values.year,
		cuid:values.year,
		selectedcustomerexchange:values},()=>{})
	}
	else
	{
		 this.setState({ custid:0,selectedcustomerexchange:[]})
	}
}
onloadCustomerexchangeBind=(event)=>{
	if(event.target.value.length>2 )
	{
		axios.get(Serverurl+'ajaxcustomer.php?action=activeextender&cu_name='+event.target.value).then(resp => { 
		this.setState({ custarray:resp.data,customerrauto:[]});

			var rowsArray = this.state.custarray;
			rowsArray.map((row, i) => {	
let j=(i+1);			
				const items = {
					title:row.title,
					year:row.year,
					cu_emailid:row.cu_emailid,
					cu_phoneno:row.cu_phoneno,
					rowindex:j,			 
				};
			strCust.push(items);
			  
			});
		 
		this.setState({customerrauto:strCust},()=>{console.log(this.state.customerrauto)})
		}); 
	}
}
	
	Leadstatusgetdata() {	
		 axios.get(Serverurl+'ajaxleadstatus.php?action=getall&ls_ldm_id='+this.props.id)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
	
			this.setState({  
			  Leadstatusdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count)
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({Leadstatusdata:[],totaldata:0});
	 }
 
    });		 
	}
LeadstatusDelete(lsid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('ls_id',lsid)
	 	   
	formData.append('userid',localStorage.getItem("AYLuserid"))
	
	
	 axios.post(Serverurl+"ajaxleadstatus.php", formData, {
        }).then(res => {
    
            this.Leadstatusgetdata();
 
   
  
    
            });
 }
      }	
	  
	  EditStatus(lsid,lslmid){  
	     axios.get(Serverurl+'ajaxleadstatus.php?action=getall&ls_id='+lsid)
  .then(resp => {  
		
    if(resp.data.length>0){
this.onloaduserbyid(this.props.cuid);
    this.setState({ 
     
      ls_id:resp.data[0].ls_id,	    
type: resp.data[0].ls_type, 
comments: resp.data[0].ls_comments, 
followupdate: resp.data[0].ls_followupdate,    
  followupdate1: resp.data[0].editfollowupdate,  
  ls_reasonforlost:resp.data[0].ls_reasonforlost,  
  ls_movedtoaddress:resp.data[0].ls_movedtoaddress,  
cuid:this.props.cuid,
custid:this.props.cuid,  
    });
	
  }
  
});
	  }
	  
	  
onloaduserbyid(cuid){
		
		 axios.get(Serverurl+'ajaxcustomer.php?action=getall&cu_id='+cuid)
  .then(resp => {  
   if(resp.data.length>0){
	   const items = {
       title:resp.data[0].cu_name,
					year:resp.data[0].cu_id,
					cu_emailid:resp.data[0].cu_emailid,
					cu_phoneno:resp.data[0].cu_phoneno,
					rowindex:1,		
			
        };
 
       
    this.setState({ 
	
	
   	 	custid:resp.data[0].cu_contactname,
	   cuid: resp.data[0].cu_id,
	
	
	selectedcustomerexchange:items,
	
	
  
	});
	
   }

  });

}
	 
	handleLeadStatus = (e) => {
		this.setState({ open:!this.state.open,name:'',ls_id:0,type:'',comments:'',followupdate:'',errormessage:'',erropen:false,btndisabled:false,
submitbtn:"Save" 
		
		});
		this.Leadstatusgetdata();
	};
	handleClickOpenPayment = (e) => {
		this.setState({ 
		paymentdate:'',paymentreferenceno:'',paymenttype:'',paymentcomments:'',paymentsamount:'',pa_id:0,
		errormessage:'',erropen:false,balamt:0,
		});		
	}
	myChangeHandler = (event) => {
		const re = /^[0-9\b]+$/;
		let nam = event.target.name;
		let val = event.target.value;
		this.setState({[nam]: val}); 
	}
	
	handleChangePage = (event, newPage) => {
  this.setState({ page: newPage });
};

handleChangeRowsPerPage = (event) => {
  this.setState({
    rowsPerPage: parseInt(event.target.value, 10),
    page: 0,
  });
};

	handleStatusClose = (e) => {
			
	
 let followupdate = this.state.followupdate1;
  let type = this.state.type;
  let comments = this.state.comments;
   let cuid = this.state.cuid; 
   let ls_reasonforlost = this.state.ls_reasonforlost;  
   let ls_movedtoaddress = this.state.ls_movedtoaddress;    
  
if(type==="")
{
	
	this.setState({errormessage:"Please Select Type",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}if(type==="4")
{
if(followupdate==="")
{
	
	this.setState({errormessage:"Please Enter Follow Up Date.",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}}
if(type==="3")
{
if(cuid===0)
{
	this.setState({errormessage:"Please Select Customer.",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
}

if(type==="5")
{if(ls_reasonforlost==="")
{
	this.setState({errormessage:"Please Select Customer.",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}	
}
 this.setState({bntsavedisable:true,submitbtn:"Processing...",errormessage:"",erropen:false})
   var formData = new FormData();
  
  
   if(this.state.ls_id==0)
	  {
		  formData.append('ls_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('ls_id',this.state.ls_id)
		
      }
		formData.append('action','statusinsert') 
		formData.append('ls_followupdate',followupdate)	
		formData.append('ls_type',type)
			formData.append('ls_ldm_id',this.props.id)
		formData.append('ls_movedtoaddress',ls_movedtoaddress)
				formData.append('ls_cu_id',cuid)
		//formData.append('ls_reasonforlost',ls_reasonforlost)
		formData.append('ls_reasonforlost',(ls_reasonforlost == null || ls_reasonforlost === '') ? 0 : ls_reasonforlost)
		formData.append('ls_comments',comments)			
		formData.append('userid',localStorage.getItem("AYLuserid"))		  
		axios.post(Serverurl+"ajaxleadstatus.php", formData, {
        }).then(res => {
    
	
	
	if(res.data === -1)
{ 
	 

		this.setState({errormessage:"",erropen:true,open:true,bntsavedisable:false,submitbtn:"Save",
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
		if(type!=="2")
		{
		this.setState({ btndisabled:false,ls_id:0,comments:'',type:'',bntsavedisable:false,submitbtn:"Save",
	 submitbtn:"Save", ls_reasonforlost:'',ls_movedtoaddress:'',});
		}else{
			this.setState({ btndisabled:false,ls_id:0,comments:'',type:'',ls_reasonforlost:'',ls_movedtoaddress:'',
	 submitbtn:"Save", redirect:true,pagename:'/Adminbilling?ldid='+this.props.id });
		}
		 this.Leadstatusgetdata();
	}
	
	
            
    
        });
  
	
	
	};
	handleErrorclose=(event)=>{
		this.setState({erropen: false});  
	} 
	handleIconClose = (e) => {
this.setState({ open:false})
this.props.updateDonenew();
};
handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ followupdate:dayjs(date),
followupdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
	render (){	
  
   if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	
	return(
	<React.Fragment>
	
	
    <Dialog open={this.state.open} onClose={this.handleStatusClose} maxWidth="xl" fullWidth="true" aria-labelledby="form-dialog-title">

	<DialogTitle id="form-dialog-title">Lead Status <div className="floatright">
	 < HighlightOffIcon onClick={this.handleIconClose} />
	 </div><div className="clear"></div></DialogTitle>
	<DialogContent>
	
	 
	 
	 
	<p>
		<Collapse in={this.state.erropen}>
		<Alert
		action={
		<IconButton
		aria-label="close"
		color="inherit"
		size="small"
		onClick={() => {
		this.handleErrorclose();
		}}
		>
		<CloseIcon fontSize="inherit" />
		</IconButton>
		} severity="error"
		>
		{this.state.errormessage}
		</Alert>
		</Collapse>
	</p>
	<div className="searchmaster">
<ul>


 <li><p><span className="validation">*</span> Type </p>
 <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler} className="txtbox"
          id="type"
		   value={this.state.type}
		  name="type"
		
        >
	
	<option value="">Select Type</option>
	{(this.props.cuid==="0") && (<React.Fragment>
          <option value={2}>New Subsciption</option>
          <option value={3}>Assign Customer</option> 
</React.Fragment>	)}
{(this.state.ls_id!==0) && (<React.Fragment>
          <option value={2}>New Subsciption</option>
          <option value={3}>Assign Customer</option> 
</React.Fragment>	)}
 <option value={4}>Follow Up </option>
 <option value={5}>Lost </option>
        </Select>

		</FormControl>
		
		 
 </p></li>
 {this.state.type ==="4" && (
 <li>
	<p><span className="validation">*</span> Followup date </p>
		<p>
		<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.followupdate) }
className="txtbox"  inputProps={{tabIndex: "1"}} 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>

 </p>
</li>
 	
 )}
 {this.state.type ==="3" && ( <li>
<p><span className="validation">*</span> Assign Customer </p> <p>

<Autocomplete
      id="free-solo-demo"
      
      className="txtbox"  inputValue={this.state.custid}
	    defaultValue={this.state.selectedcustomerexchange}
      options={this.state.customerrauto}   onInputChange={this.onInputCustChange}
	   onChange={this.onTagscustomerexchange} 
	    value={this.state.selectedcustomerexchange}
      renderInput={(params) => (
        <TextField {...params} className="txtbox" onChange={this.onloadCustomerexchangeBind}  variant="outlined" />
      )}
 getOptionLabel={(option) => option.title || ""}

      renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
          
            <tbody>
              <tr {...props}>
                <td width='10%'>{option.title}</td>
               
				
                <td width='10%'>{option.cu_phoneno}</td>
				
              </tr>
            </tbody>
          </table>
        </React.Fragment>
      )}
    />
</p></li>
 	
 )}
 {this.state.type === "5"  && ( 
		
		<li>		
						  
		<p> <span className="validation">*</span>Reason</p>				  
						  <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler}
          id="ls_reasonforlost"
		   value={this.state.ls_reasonforlost} inputProps={{tabIndex: "9"}} className="txtbox"
		  name="ls_reasonforlost"
		
        >
	
	<option value="">Select Reason</option>
          <option value={1}>Location</option>
          <option value={2}>Not Interested</option>
 <option value={3}>High price</option>
 <option value={4}>Time issue</option>

 

        </Select>

		</FormControl>
		</p>
		{this.state.ls_reasonforlost === "1"  && ( 
		
			 <React.Fragment>	

		<p> <span className="validation">*</span>Moved To Address</p>
	
	<p>  
	<TextField name="ls_movedtoaddress" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ls_movedtoaddress}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "11",maxLength:13}} className="txtbox" 
	   InputLabelProps={{ shrink: true }}
                          /></p>	



		 </React.Fragment>
			)}
		</li>
		
	)}
	
<li>
<p>Comments:</p>
 <p><TextField name="comments" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={3}
	   value={this.state.comments}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "3",maxLength:400}} 
	   InputLabelProps={{ shrink: true }}
                          /> </p>		

</li>		  
		
 <li>
   <p className="aligncentr">
       <Button variant="contained" className="frmSecondarybtn" disable={this.state.bntsavedisable} onClick={this.handleStatusClose}>
   {this.state.submitbtn}
</Button></p>
 </li>
   </ul>
   </div>
	
	
	</DialogContent>
	
	<div className="main">
	<h1 >Lead Status</h1>
	
	<Paper className={useStyles.root}>
		<TableContainer className={useStyles.container}>  
		<Table stickyHeader aria-label="sticky table">

	<TableHead> 
<TableRow>
                                              
       <TableCell>Type</TableCell> <TableCell>Date</TableCell>  <TableCell>Reason for Lost</TableCell>              
			 <TableCell>Comments</TableCell>  			
                      </TableRow></TableHead>

	<TableBody>
	{
		/*stableSort(this.state.Leadstatusdata, 
		getSorting(this.state.orderBy,
		this.state.order))*/
		stableSort(this.state.Leadstatusdata, getSorting(this.state.order, this.state.orderBy))
  .slice(
    this.state.page * this.state.rowsPerPage,
    this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
  )
  .map((lestatus,index) => { 

		
		return (
		<React.Fragment>				
		<TableRow key={index}>
				
	<TableCell>{lestatus.type}</TableCell>	
<TableCell>{lestatus.followupdate}</TableCell>
<TableCell><b>{lestatus.reasonlast}</b>
	{lestatus.ls_movedtoaddress!=="" && (
	<p>{lestatus.ls_movedtoaddress}</p>
	)}

</TableCell>
		<TableCell>{lestatus.ls_comments}</TableCell>	
		<TableCell align="left">
	
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.EditStatus(lestatus.ls_id,lestatus.ls_ldm_id)}} endIcon={<EditIcon />}>
Edit
</Button>&nbsp;&nbsp;
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.LeadstatusDelete(lestatus.ls_id)}} endIcon={<DeleteIcon />} >
  Delete
</Button> 
		</TableCell>
		</TableRow>
		</React.Fragment>
		);
		}
	)}
	</TableBody>
	</Table>
	<TablePagination
  rowsPerPageOptions={[4, 10, 15, 20]}
  component="div"
  count={this.state.Leadstatusdata.length}
  rowsPerPage={this.state.rowsPerPage}
  page={this.state.page}
  onPageChange={this.handleChangePage}
  onRowsPerPageChange={this.handleChangeRowsPerPage}
/>

	</TableContainer>
	
	</Paper>	
	</div>
	</Dialog>
	</React.Fragment>
	)} 
} 

/*end of new component*/


  
 

  




